<template>
      <section class="services" id="services">
      <h1 class="heading">
        Diensten
      </h1>
      <div class="box-container container">
        <div class="box" @click="$router.push('/mondhygiene')">
          <img src="../assets/images/services-icon-1.png" alt="Preventieve Tandheelkunde icoon">
          <h3>Preventieve Tandheelkunde</h3>
          <p>Regelmatige controles, gebitsreiniging en voorlichting om tandproblemen vroegtijdig te voorkomen.</p>
          <router-link to="/mondhygiene" class="service-link">Meer informatie</router-link>
        </div>
        <div class="box" @click="ScrollToServicesSection('cosmetic-dentistry')">
          <img src="../assets/images/services-icon-2.png" alt="Restauratieve Tandheelkunde icoon">
          <h3>Restauratieve Tandheelkunde</h3>
          <p>Herstel van beschadigde of aangetaste tanden met vullingen, kronen en bruggen.</p>
          <span class="service-link">Meer informatie</span>
        </div>
        <div class="box" @click="$router.push('/cosmetische-tandheelkunde')">
          <img src="../assets/images/services-icon-5.png" alt="Cosmetische Tandheelkunde icoon">
          <h3>Cosmetische Tandheelkunde</h3>
          <p>Verbetering van uw glimlach met behandelingen zoals tanden bleken, facings en kroonwerk.</p>
          <router-link to="/cosmetische-tandheelkunde" class="service-link">Meer informatie</router-link>
        </div>
        <div class="box" @click="ScrollToServicesSection('root-canal-specialist')">
          <img src="../assets/images/services-icon-4.png" alt="Parodontale Zorg icoon">
          <h3>Parodontale Zorg</h3>
          <p>Behandeling van tandvleesaandoeningen en ondersteuning bij het behouden van een gezond tandvlees.</p>
          <span class="service-link">Meer informatie</span>
        </div>
        <div class="box" @click="$router.push('/mondhygiene')">
          <img src="../assets/images/services-icon-3.png" alt="Mondhygiëne icoon">
          <h3>Mondhygiëne</h3>
          <p>Professionele gebitsreiniging en advies over mondverzorging voor een langdurig gezonde mondgezondheid.</p>
          <router-link to="/mondhygiene" class="service-link">Meer informatie</router-link>
        </div>
        <div class="box" @click="$router.push('/wortelkanaalbehandeling')">
          <img src="../assets/images/services-icon-6.png" alt="Endodontologie icoon">
          <h3>Endodontologie</h3>
          <p>Wij proberen uw tand of kies te redden met een wortelkanaalbehandeling: geïnfecteerd weefsel wordt verwijderd en het kanaal zorgvuldig afgedicht.</p>
          <router-link to="/wortelkanaalbehandeling" class="service-link">Meer informatie</router-link>
        </div>
      </div>
    </section>
</template>

<script>
export default {
    name: "ServicesSection",
    methods: {
      ScrollToServicesSection(servicesection) {
          this.$router.push({ path: '/diensten' })
          this.$store.commit('updateScrollToServices', servicesection)   // scroll to right service section 
      },
    }
}
</script>

<style scoped>
.services {
  background-color: var(--light-bg);
}
.services .box-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
  gap: 2rem;
}
.services .box-container .box {
  text-align: center;
  padding: 2rem;
  background-color: var(--white);
  box-shadow: var(--box-shadow);
  border-radius: .5rem;
  transition: 0.5s;
  cursor: pointer;
}
.services .box-container .box:hover {
  box-shadow: 0 0 20px 0px rgba(0,0,0,0.2);
  transform: translateY(-3px);
}
.services .box-container .box img {
  margin: 1rem 0;
  height: 4rem;
}
.services .box-container .box h3{
  font-size: 2rem;
  padding: 1rem 0;
  color: var(--black);
}
.services .box-container .box p {
  font-size: 1.5rem;
  color: var(--light-color);
  line-height: 2;
}
.services .box-container .box .service-link {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.5rem 1.5rem;
  background-color: var(--blue);
  color: var(--white);
  text-decoration: none;
  border-radius: 5px;
  font-size: 1.4rem;
  transition: all 0.3s ease;
}
.services .box-container .box .service-link:hover {
  background-color: var(--black);
  color: var(--white);
  text-decoration: none;
}
</style>